module.exports = __webpack_public_path__ + "static/nxrt-mainpage4-b862834e7da42b2ef2f982199b2e94c5.jpg";